var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.306,
    height: 16.798,
    viewBox: "0 0 18.306 16.798",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "learn-icon",
    d: "M16.813,24.1l-5.624-2.68a3.986,3.986,0,0,0-4.03-.034L1.471,24.1c-.021.011-.043.022-.064.034a2.815,2.815,0,0,0,.064,4.924L3.04,29.8v3.737a3.819,3.819,0,0,0,2.684,3.644,11.866,11.866,0,0,0,3.418.467,11.867,11.867,0,0,0,3.418-.463,3.819,3.819,0,0,0,2.684-3.644V29.8l1.526-.729v6.291a.763.763,0,1,0,1.525,0V26.211A2.554,2.554,0,0,0,16.813,24.1Zm-3.094,9.447a2.288,2.288,0,0,1-1.6,2.184,10.367,10.367,0,0,1-2.975.4,10.367,10.367,0,0,1-2.975-.4,2.288,2.288,0,0,1-1.6-2.184V30.53L7.1,31.735a4.021,4.021,0,0,0,2.063.564,3.814,3.814,0,0,0,1.966-.529l2.594-1.24Zm2.441-5.866-5.753,2.746a2.512,2.512,0,0,1-2.586-.034L2.193,27.713a1.291,1.291,0,0,1-.028-2.256l5.717-2.731a2.517,2.517,0,0,1,2.586.034l5.624,2.68a1.318,1.318,0,0,1,.678,1.137,1.3,1.3,0,0,1-.61,1.1Z",
    transform: "translate(0.011 -20.854)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnIcon);
export default __webpack_public_path__ + "static/media/learn-icon.1794a18a2cdcee2e3ee2f276d113f345.svg";
export { ForwardRef as ReactComponent };